import * as React from "react";
import type { SVGProps } from "react";
const SvgFluctuationIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="fluctuation_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M406.997 298.667c17.11-.128 32.683 10.197 39.51 26.154L552.32 572.544l70.57-143.701a42.667 42.667 0 0 1 38.4-24.064 42.667 42.667 0 0 1 38.23 24.405l100.693 209.067h95.702c23.594 0 42.752 19.498 42.752 43.52 0 24.064-19.158 43.562-42.752 43.562H773.547a42.667 42.667 0 0 1-38.4-24.362l-74.411-154.539-72.875 148.395a42.667 42.667 0 0 1-39.381 24.021c-16.64-.427-31.445-10.667-38.059-26.155l-102.4-239.616-100.906 245.547c-6.656 16.213-22.187 26.71-39.424 26.71H128.085a43.136 43.136 0 0 1-42.752-43.52c0-24.065 19.158-43.52 42.752-43.52h111.147l128.64-312.918c6.613-16.085 22.016-26.581 39.125-26.71z"
    />
  </svg>
);
export default SvgFluctuationIcon;
